<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
  style="top: 80px"
>
  <mat-tab-group
    mat-align-tabs="center"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    [selectedIndex]="ViewTab.value"
    (selectedIndexChange)="ViewTab.setValue($event)"
  >
    <mat-tab label="Search containers" [disabled]="isSelected(0)">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
        >
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>From</mat-label>
            <input
              matInput
              [matDatepicker]="picker1"
              (dateInput)="addEventfrom('input', $event)"
              (dateChange)="addEventfrom('change', $event)"
              [value]="date2.value"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>

          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
          >
            <mat-label>To</mat-label>
            <input
              matInput
              [matDatepicker]="picker2"
              (dateInput)="addEventto('input', $event)"
              (dateChange)="addEventto('change', $event)"
              [value]="date.value"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2 color="primary"></mat-datepicker>
          </mat-form-field>

          <div
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
            style="margin-top: 16px"
          >
            <mat-slide-toggle
              [(ngModel)]="checked"
              class="example-margin"
              [checked]="checked"
            >
              Complete?
            </mat-slide-toggle>
          </div>
          <div
            class="
              example-button-container
              col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2
            "
            style="margin-top: 13px; margin-right: 0px"
          >
            <button
              (click)="OnViewContainer()"
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              mat-raised-button
              color="primary"
            >
              Search
            </button>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-form-field appearance="outline" class="col-md-12">
            <mat-label>Search</mat-label>
            <input
              matInput
              (keyup)="applyFilterSearch($event)"
              placeholder="Search"
              #dataSearch
            />
            <button
              mat-button
              matSuffix
              mat-icon-button
              color="primary"
              (click)="openDialogLector()"
              aria-label="Example icon button with a menu icon"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
            <mat-hint>Filter table</mat-hint>
          </mat-form-field>
          <div
            class="
         
              mat-elevation-z8
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
          >
            <div
              class="example-loading-shade"
              *ngIf="isLoadingResults || isRateLimitReached"
            >
              <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
              <div
                class="example-rate-limit-reached"
                *ngIf="isRateLimitReached"
              >
                Without Container
              </div>
            </div>

            <div class="example-table-container" #exportExcel>
              <button
                mat-button
                matSuffix
                mat-icon-button
                color="success"
                (click)="exportAsExcel()"
                aria-label="Example icon button with a menu icon"
                class="col-md-12"
              >
                Excel

                <mat-icon>cloud_download</mat-icon>
              </button>
              <table
                mat-table
                [dataSource]="datasourceConteiner"
                class="example-table"
                matSort
                matSortActive="created"
                matSortDisableClear
                matSortDirection="desc"
                #tablematSort="matSort"
              >
                <!-- Number Column -->
                <ng-container matColumnDef="Options" sticky>
                  <th mat-header-cell *matHeaderCellDef>Options</th>
                  <td mat-cell *matCellDef="let row">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="menuCon"
                      aria-label="Example icon-button with a menu"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuCon="matMenu">
                      <button
                        (click)="openDialog(row)"
                        mat-menu-item
                        *ngIf="!row.Active"
                      >
                        <span>PDF Receiving</span>
                      </button>
                      <button (click)="OnEditarContainer(row)" mat-menu-item>
                        <span>Edit Container</span>
                      </button>

                      <button
                      *ngIf="row.Active"
                        (click)="OnChangeConfirmTranfes(row)"
                        mat-menu-item
                      >
                        <span>Transfer inventory </span>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <!-- Title Column -->
                <ng-container matColumnDef="Customer">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Company Name</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{onCleaarte(row.Customer)}}</div>
                  </td>
                </ng-container>

                <!-- State Column -->
                <ng-container matColumnDef="Container">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Container</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{row.ContainerNumber}}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="References">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Reference #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{row.ReferenceNumber}}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Arrived">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Arrived</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Arrived }}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Empty">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Empty</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Empty }}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Departed">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Departed</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Departed }}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Location">
                  <th mat-header-cell *matHeaderCellDef>Location</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{row.Location}}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Pieces">
                  <th mat-header-cell *matHeaderCellDef>Pieces</th>
                  <td mat-cell *matCellDef="let row">{{ row.Pieces }}</td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Available">
                  <th mat-header-cell *matHeaderCellDef>Available</th>
                  <td mat-cell *matCellDef="let row">{{ row.Available }}</td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let row">{{ row.Status }}</td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Active">
                  <th mat-header-cell *matHeaderCellDef>Active</th>
                  <td mat-cell *matCellDef="let row">{{ row.Active }}</td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="Notes">
                  <th mat-header-cell *matHeaderCellDef>Notes</th>
                  <td mat-cell *matCellDef="let row">{{ row.Notes }}</td>
                </ng-container>
                <ng-container matColumnDef="po" stickyEnd>
                  <th mat-header-cell *matHeaderCellDef>PO#</th>
                  <td mat-cell *matCellDef="let row">{{ row.po }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          </div>
          <mat-paginator
            [length]="resultsLength"
            [pageSizeOptions]="[50, 100, 250, 1000]"
            matPaginator
            #tablePaginator="matPaginator"
            [pageSize]="50"
          ></mat-paginator>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Add container" [disabled]="isSelected(1)">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <form [formGroup]="ContainerForm">
          <mat-form-field
            appearance="fill"
            hintLabel="Company Name"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Select An Option</mat-label>
            <mat-select formControlName="custom">
              <mat-option
                *ngFor="let customer of CustomerView"
                [value]="customer.key"
                >{{ customer.value }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field
            hintLabel="Max 11 characters"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Container #</mat-label>
            <input
              matInput
              #container
              maxlength="11"
              placeholder="Container #"
              formControlName="contenedor"
              name="intext"
            />
            <mat-hint align="end"
              >{{ container.value?.length || 0 }}/11</mat-hint
            >
          </mat-form-field>
          <mat-form-field
            hintLabel="Max 10 characters"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Reference #</mat-label>
            <input
              matInput
              #references
              maxlength="250"
              placeholder="Reference #"
              formControlName="referencia"
            />
            <mat-hint align="end"
              >{{ references.value?.length || 0 }}/250 max</mat-hint
            >
          </mat-form-field>
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          >
            <mat-label>Arrived</mat-label>
            <input
              matInput
              [matDatepicker]="arrivedDate"
             
              formControlName="arrived"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="arrivedDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #arrivedDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
            *ngIf="isLDT"
          >
            <mat-label>Empty</mat-label>
            <input
              matInput
              [matDatepicker]="emptyDate"
             
              formControlName="empty"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="emptyDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #emptyDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            color="accent"
            appearance="fill"
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          >
            <mat-label>Departed</mat-label>
            <input
              matInput
              [matDatepicker]="departedDate"
   
              formControlName="departed"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="departedDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #departedDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          >
            <mat-label>Status</mat-label>
            <mat-select formControlName="estatus">
              <mat-option
                *ngFor="let estats of ArrayEstatusContenedor"
                [value]="estats.key"
                >{{ estats.value }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field
            hintLabel="Max 150 characters"
            appearance="fill"
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
          >
            <mat-label>Location</mat-label>
            <input
              matInput
              #container
              maxlength="150"
              placeholder="Location"
              formControlName="location"
            />
            <mat-hint align="end"
              >{{ container.value?.length || 0 }}/150</mat-hint
            >
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          >
            <mat-label>Total</mat-label>
            <input
              matInput
              type="number"
              placeholder="Total"
              min="1"
              formControlName="total"
            />
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          >
            <mat-label>Available</mat-label>
            <input
              matInput
              type="number"
              placeholder="Available"
              min="1"
              formControlName="available"
            />
          </mat-form-field>
          <mat-form-field
            appearance="fill"
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
          >
            <mat-label>PO#</mat-label>
            <input
              matInput
              type="text"
              placeholder="PO#"
              formControlName="po"
            />
          </mat-form-field>

          <mat-form-field
            appearance="fill"
            class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
          >
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="notes"></textarea>
          </mat-form-field>
          <mat-checkbox
            class="
            example-margin
            col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3
          "
            formControlName="actived"
            >New Container?</mat-checkbox
          >
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              btn-group
            "
          >
            <button
              mat-raised-button
              color="warn"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              (click)="OnCancel()"
              type="button"
            >
              Clear
            </button>

            <button
              mat-raised-button
              color="primary"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              (click)="OnNewContainer(0)"
              *ngIf="!editar"
              type="button"
            >
              Add
            </button>
            <button
              mat-raised-button
              color="primary"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              (click)="OnNewContainer(update)"
              *ngIf="editar"
              type="button"
            >
              Update
            </button>
            <button
              mat-raised-button
              color="warning"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              (click)="onviewAddProducts()"
              *ngIf="editar"
              type="button"
            >
              Add Products
            </button>
            <button
              mat-raised-button
              color="success"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              (click)="onviewConfirmProducts()"
              *ngIf="editar"
              type="button"
            >
              Confirm produts
            </button>
            <button
              mat-raised-button
              color="danger"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              (click)="onviewBillofLadingProducts()"
              *ngIf="!viewbuttonbilloflading"
              type="button"
            >
             view Bill of lading
            </button>
          </div>
        </form>

        <div *ngIf="editar">
          <div
            style="border: 3px solid;border-color: rgb(89, 42, 165);margin-top: 3vh;"
            *ngIf="viewAddProduct"
            class=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
            [formGroup]="FormItemsContainer"
          >
            <div
              class=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            >
              <h1 style="font-size: 16pt !important;"><b>ADD PRODUCTS TO CONTAINER</b></h1>
              <button
                mat-raised-button
                color="primary"
                class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
                style="bottom: 7px;height: 5vh !important;"
                (click)="OnSelectProductsItems()"
              >
                Clear
              </button>
              <mat-slide-toggle
                [checked]="checked2"
                (click)="ModalProducts()"
                class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
              >
                New product
              </mat-slide-toggle>
            </div>
            <div
              style="
height: 16vh !important;
"
              class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 InputSty"
            >
              <mat-form-field
                appearance="fill"
                class="
col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
"
              >
                <mat-label>Products</mat-label>
                <input
                  type="text"
                  matInput
                  [formControl]="myControl"
                  [matAutocomplete]="auto"
                  id="product"
                  class="product"
                  (keydown.@)="onKeydown($event)"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="displayFn"
                >
                  <mat-option
                    *ngFor="let option of filteredOptions | async"
                    [value]="option"
                  >
                    {{ "Product: " + option.ItemNumber + ", Description: " +
                    option.ItemDescription }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1">
              <mat-form-field
                appearance="fill"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
              >
                <mat-label>Quantity</mat-label>
                <input
                  matInput
                  type="number"
                  placeholder="Quantity"
                  min="1"
                  formControlName="quantity"
                />
              </mat-form-field>
            </div>
            <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1">
              <mat-form-field appearance="fill">
                <mat-label>Select an type</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="PLTS">PLTS</mat-option>
                  <mat-option value="CTNS">CTNS</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
           <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              style="margin-top: 1.5vh !important;"
            >
            <mat-form-field  appearance="fill"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty">
              <mat-label>Search Location</mat-label>
              <input matInput (keyup)="applyFilterLocation($event)" #input />
             
              <mat-hint>Filter Location</mat-hint>
            </mat-form-field>
           </div>
            <div
              class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1"
              style="margin-top: 2vh !important;"
            >
              <mat-form-field
                appearance="fill"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
              >
                <mat-label>Location</mat-label>
                <mat-select formControlName="location" #locations>
                  <mat-option
                    *ngFor="let item of ArrayLocations"
                    [value]="item.id"
                    >Location: {{ item.location }} - Description: {{ item.locationDescription }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              style="margin-top: 1vh !important;"
            >
              <mat-form-field
                appearance="fill"
                class="
col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty
"
              >
                <mat-label>Note</mat-label>
                <textarea matInput formControlName="Note"></textarea>
              </mat-form-field>
            </div>

            <mat-form-field
              appearance="fill"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              *ngIf="false"
            >
              <mat-label>PO#</mat-label>
              <input
                matInput
                type="text"
                placeholder="PO#"
                formControlName="proNumber"
              />
            </mat-form-field>

            <mat-form-field
              appearance="fill"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              *ngIf="false"
            >
              <mat-label>Pallet</mat-label>
              <input
                matInput
                type="number"
                placeholder="Pallet"
                min="1"
                formControlName="pallet"
              />
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              *ngIf="false"
            >
              <mat-label>Weight</mat-label>
              <input
                matInput
                type="number"
                placeholder="Weight"
                min="1"
                formControlName="weight"
              />
            </mat-form-field>
            <button
              mat-raised-button
              color="primary"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
              style="bottom: 7px;height: 5vh !important;"
              (click)="onAddItemsContainer()"
              *ngIf="!viewEditItemsContainer"
            >
              Add
            </button>
            <button
              mat-raised-button
              color="primary"
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
              style="bottom: 7px;height: 5vh !important;"
              (click)="onUpdateItemsContainer()"
              *ngIf="viewEditItemsContainer"
            >
              Update
            </button>
            <div
              class=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
              style="
height: 40vh !important;
overflow: scroll;margin-top: 2vh;
"
            >
              <button
                mat-raised-button
                color="primary"
                class="printPageButton"
                (click)="OnSelectItemsContainer()"
              >
                Refresh
              </button>
              <table
                class="table table-bordered"
                *ngIf="viewTable"
                style="width: 100% !important"
              >
                <thead>
                  <tr>
                    <th>Options</th>
                    <th>Item Number</th>
                    <th>Quantity</th>
                    <th>Pallet</th>
                    <th>Location</th>
                    <th>Type</th>
                    <th *ngIf="false">Received</th>
                    <th>Status</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of arrayItemsContainer; let i=index">
                    <td>
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="menuIt"
                        aria-label="Example icon-button with a menu"
                      >
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menuIt="matMenu">
                        <button
                          (click)="OnEditarItemsContainer(item)"
                          mat-menu-item
                        >
                          <span>Edit</span>
                        </button>

                        <button
                          (click)="OnDeleteItemsContainer(item)"
                          mat-menu-item
                        >
                          <span>Delete</span>
                        </button>
                      </mat-menu>
                    </td>
                    <td>{{item.ItemNumber}}</td>
                    <td>{{item.Quantity}}</td>
                    <td>{{item.palletQuantity}}</td>
                    <td>{{item.Location}}</td>
                    <td>{{item.type_items}}</td>
                    <td *ngIf="false">{{item.receiveQuantity}}</td>
                    <td>
                      <p *ngIf="item.Active==1">PENDING CONFIRMATION</p>
                      <p *ngIf="item.Active==2">CONFIRMED</p>
                    </td>
                    <td>{{item.note}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
          *ngIf="viewConfirmProduts"
            style="border: 3px solid;border-color: rgb(42, 165, 108);margin-top: 3vh;"
          >
           

            <h1 style="font-size: 16pt !important;">
              <b>CONFIRM THE PRODUCTS IN THE CONTAINER</b>
            </h1>
            <br />
            <div  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" [formGroup]="FormConfirmItems">
              <mat-form-field appearance="fill" class="col-md-3">
                <mat-label>Select an item</mat-label>
                <mat-select
                  #selectitemsComfir
                  formControlName="itemsContainer"
                  (selectionChange)="OnselectitemsconfirmContaimer($event.value)"
                >
                  <mat-option
                    *ngFor="let item of arrayItemsContainer; let i=index"
                    [value]="item.receiveItemsID"
                    >{{item.ItemNumber}}/{{item.Quantity}}/{{item.type_items}}</mat-option
                  >
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="fill"
                class="col-md-2"
                *ngIf="tablepalletNumber"
              >
                <mat-label>PLT#</mat-label>
                <input
                  matInput
                  formControlName="palletNumber"
                  placeholder="Pallet#"
                />
              </mat-form-field>
              <mat-form-field
                appearance="fill"
                class="col-md-2"
                *ngIf="tablePalletQuantity"
              >
                <mat-label>PLT</mat-label>
                <input matInput formControlName="palletQty" placeholder="PLT" />
              </mat-form-field>
              <mat-form-field appearance="fill" class="col-md-2">
                <mat-label>QTY</mat-label>
                <input matInput formControlName="Qty" placeholder="QTY" />
              </mat-form-field>

              <mat-form-field appearance="fill" class="col-md-2">
                <mat-label>TYPE</mat-label>
                <mat-select formControlName="typePallet">
                  <mat-option value="PLTS">PLTS</mat-option>
                  <mat-option value="CTNS">CTNS</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="fill"
                class="col-md-2"
                *ngIf="tablePalletQuantity"
              >
                <mat-label>Weight</mat-label>
                <input
                  matInput
                  formControlName="weight_items"
                  placeholder="Weight"
                />
              </mat-form-field>
              <button
                mat-raised-button
                color="primary"
                (click)="OninsertUpdateConfirmItems()"
              >
                {{labelAddConf}}
              </button>
              <button
              mat-raised-button
              color="primary"
              (click)="onclearConfirmProducts()"
            >
          Clear
            </button>
            </div>

            <div class=" col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6" style="height: 50vh !important;overflow: scroll;">
              <button
              mat-raised-button
              color="primary"
              class="printPageButton"
              (click)="OnSelectItemsContainer()"
            >
              Refresh
            </button>
              <table class="table" style="width: 100% !important">
                <thead>
                  <tr>
                    <th>OPTIONS</th>
                    <th>ITEM NUMBER</th>
                    <th>TYPE</th>
                    <th *ngIf="tablepalletNumber">PLT#</th>
                    <th *ngIf="tablePalletQuantity">PLT</th>
                    <th *ngIf="tablePalletQuantity">WEIGHT</th>
                    <th>QTY</th>
                    <th>DATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let itemcc of ArrayDetailsConfirmItems; let i=index"
                  >
                    <td>
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="menuCosn"
                        aria-label="Example icon-button with a menu"
                      >
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menuCosn="matMenu">
                        <button
                          mat-menu-item
                          (click)="OnEditItemsConfirm(itemcc)"
                        >
                          <span>Edit</span>
                        </button>
                        <button
                          mat-menu-item
                          (click)="OnDeleteitemsconfirmContaimer(itemcc)"
                        >
                          <span>Delete</span>
                        </button>
                      </mat-menu>
                    </td>
                    <td>{{onsearchnameProduct(itemcc.id_items_container)}}</td>
                    <td>{{itemcc.type_unit}}</td>
                    <td *ngIf="tablepalletNumber">{{itemcc.pallet_number}}</td>
                    <td *ngIf="tablePalletQuantity">{{itemcc.pallet_qty}}</td>
                    <td *ngIf="tablePalletQuantity">{{itemcc.weight_items}}</td>
                    <td>{{itemcc.qty_items}}</td>
                    <td>{{itemcc.datecreate}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
            class=" col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
            style="
height: 50vh !important;
overflow: scroll;margin-top: 2vh;
"
          >
            <button
              mat-raised-button
              color="primary"
              class="printPageButton"
              (click)="OnSelectSummaryViewPanel()"
              *ngIf="tablepalletNumber"
            >
              Refresh
            </button>
            <table   *ngIf="tablepalletNumber" class="table table-bordered" style="width: 100% !important">
              <thead>
                <tr>
                  <th>Item Number</th>
                  <th>Quantity</th>
                  <th *ngIf="false">Pallet</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let item of arrayItemsContainerSummary; let i=index"
                >
                  <td>{{item.ItemNumber}}</td>
                  <td>{{item.qty_items}}</td>

                  <td *ngIf="false">{{item.pallet_qty}}</td>
                </tr>
              </tbody>
            </table>

            <button
              mat-raised-button
              color="primary"
              class="printPageButton"
              (click)="OnSelectSummaryViewPanel()"
              *ngIf="tablePalletQuantity"
            >
              Refresh
            </button>
            <table   *ngIf="tablePalletQuantity" class="table table-bordered" style="width: 100% !important">
              <thead>
                <tr>
                  <th>Item Number</th>
                  <th>Unit</th>
                  <th>Quantity</th>
                  <th>Pallet</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let item of arrayItemsContainerSummary; let i=index"
                >
                  <td>{{item.ItemNumber}}</td>
                  <td>{{item.type_unit}}</td>
                  <td>{{item.qty_items}}</td>

                  <td>{{item.pallet_qty}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          </div>
          <div
          *ngIf="viewBillofLading"
            style="border: 3px solid;border-color: rgb(165, 42, 42);margin-top: 3vh;"
          >
           
            <h1 style="font-size: 16pt !important;"><b>BILL OF LADING PDF</b></h1>
            <br />
            <div style="height: 40vh !important;overflow: scroll;">
              <button
                mat-raised-button
                color="primary"
                class="printPageButton"
                (click)="onpdfTableBillOfLading()"
              >
                PDF download all
              </button>
              <table class="table" style="width: 100% !important">
                <thead>
                  <tr>
                    <th>OPTIONS</th>
                    <th>PRO#</th>
                    <th>BILL#</th>
                    <th>From</th>

                    <th>TO</th>
                    <th>Bill</th>
                    <th>Amt$</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let itemss of arrayBilloflading">
                    <td>
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="menuBilllist"
                        aria-label="Example icon-button with a menu"
                      >
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menuBilllist="matMenu">
                        <button
                          (click)="openDialogPdfPageLabelContainerEdit(itemss)"
                          mat-menu-item
                        >
                          <span>Edit</span>
                        </button>

                        <button
                          (click)="OnSelectBillOfLadingDelete(itemss.id_bill)"
                          mat-menu-item
                        >
                          <span>Delete</span>
                        </button>
                      </mat-menu>
                    </td>
                    <td>{{itemss.pronumber}}</td>
                    <td>{{itemss.id_bill}}</td>
                    <td>{{itemss.From}}</td>
                    <td>{{itemss.To}}</td>
                    <td>{{itemss.Bill}}</td>
                    <td>{{itemss.Amt}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          *ngIf="false"
          style="margin-top: 4vh !important;height: 90vh !important;overflow: auto;"
        >
          <div
            *ngIf="viewTable"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <div class="panel panel-default" #pdfTable3>
              <!-- Default panel contents -->

              <p style="color: black !important;" *ngIf="tablepalletNumber">
                <b>REFERENCES#:</b> {{referenceContainer}}
              </p>

              <!-- Table -->

              <table *ngIf="tablepalletNumber" class="table">
                <thead>
                  <tr>
                    <th style="border: 1px solid !important;">LOCATION</th>
                    <th style="border: 1px solid !important;">ITEM NUMBER</th>
                    <th style="border: 1px solid !important;">PIECES</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>
                    <th style="border: 1px solid !important;">PLT#</th>

                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">QTY EXP.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of arrayIte; let i=index">
                    <td style="border: 1px solid !important;width: 60px;">
                      {{onCleaarte(labelCust)}}
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      {{item.ItemNumber}}
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.NumberInMaster"
                          type="number"
                        />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto1" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty1" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto2" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty2" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto3" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty3" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto4" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty4" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto5" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty5" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto6" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty6" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto7" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty7" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto8" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty8" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.pto9" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty9" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.pto10"
                          type="number"
                        />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.qty10"
                          type="number"
                        />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.pto11"
                          type="number"
                        />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.qty11"
                          type="number"
                        />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      {{item.qtyexp}}
                    </td>
                  </tr>
                  <tr>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>

                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;">
                      TOTAL
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      {{totalTable}}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table *ngIf="false" class="table">
                <thead>
                  <tr>
                    <th style="border: 1px solid !important;">LOCATION</th>
                    <th style="border: 1px solid !important;">ITEM NUMBER</th>
                    <th style="border: 1px solid !important;">PIECES</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>

                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">PLT</th>
                    <th style="border: 1px solid !important;">QTY</th>

                    <th style="border: 1px solid !important;">QTY EXP.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of arrayIte; let i=index">
                    <td style="border: 1px solid !important;width: 60px;">
                      {{onCleaarte(labelCust)}}
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      {{item.ItemNumber}}
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.NumberInMaster"
                          type="number"
                        />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl1" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty1" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl2" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty2" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl3" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty3" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl4" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty4" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl5" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty5" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl6" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty6" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl7" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty7" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl8" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty8" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.ptl9" type="number" />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input matInput [(ngModel)]="item.qty9" type="number" />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.ptl10"
                          type="number"
                        />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.qty10"
                          type="number"
                        />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.ptl11"
                          type="number"
                        />
                      </mat-form-field>
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      <mat-form-field
                        appearance="fill"
                        *ngIf="ocultarT"
                        style="width: 120px !important;"
                      >
                        <mat-label></mat-label>
                        <input
                          matInput
                          [(ngModel)]="item.qty11"
                          type="number"
                        />
                      </mat-form-field>
                    </td>

                    <td style="border: 1px solid !important;width: 60px;">
                      {{item.qtyexp}}
                    </td>
                  </tr>
                  <tr>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>

                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;"></td>
                    <td style="border: 1px solid !important;width: 60px;">
                      TOTAL
                    </td>
                    <td style="border: 1px solid !important;width: 60px;">
                      {{totalTable}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div
          *ngIf="editar"
          style="border: 3px solid;border-color: rgb(165, 42, 42);margin-top: 3vh;"
        >
          <h1
            mat-dialog-title
            class="col-md-12 printPageButton"
            style="text-align: center !important;"
          >
            <button
              mat-raised-button
              color="primary"
              class="printPageButton"
              (click)="onpdfTable()"
            >
              PDF Table Confirm Items
            </button>
            <button
              mat-raised-button
              color="primary"
              class="printPageButton"
              (click)="onpdfTableSummary()"
            >
              PDF Container Receiving Summary
            </button>
            <button
              *ngIf="false"
              mat-raised-button
              color="primary"
              class="printPageButton"
              (click)="onpdfTablePageLabel()"
            >
              PDF Container Receiving Label
            </button>
            <button
              mat-raised-button
              color="primary"
              class="printPageButton"
              (click)="openDialogPdfPageLabelContainer()"
              *ngIf="!viewbuttonbilloflading"
            >
              New Bill of Lading
            </button>
            <button
              mat-raised-button
              color="success"
              (click)="onComplete()"
              *ngIf="editar"
              type="button"
            >
              Complete Container
            </button>
          </h1>

         
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
></ngx-spinner>
